var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-dropzone',{ref:"dropzone",attrs:{"id":"editdropzone","options":_vm.options},on:{"vdropzone-complete":function($event){_vm.$emit('fileAdd', $event)},"vdropzone-removed-file":function($event){_vm.$emit( 'remove', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }